import { useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import {
  DEFAULT_PARAMS,
  FILTER_TYPE,
} from '../../../common/filterCompany/constant'
import FilterCompanyDisplay from '../../../common/filterCompany/filterDisplay'
import { selectParamsSettingDisableApi } from '../../../common/filterCompany/store/slice'

export const FilterCompany = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const isLibrary = searchParams.get('library') === 'true'
  const portfolioId = searchParams.get('portfolio')

  const paramsDisableApi = useSelector(selectParamsSettingDisableApi)

  const onClickFilter = () => {
    setSearchParams({ settings: 'true' })
  }

  return (
    <div style={{ marginTop: 12 }}>
      <FilterCompanyDisplay
        filterType={FILTER_TYPE.PORTFOLIO_INSIGHTS}
        onClickFilter={onClickFilter}
        isDisableApi={isLibrary}
        settingParamsWhenDisable={
          portfolioId
            ? {
                ...DEFAULT_PARAMS,
                portfolioIds: [Number(portfolioId)],
              }
            : paramsDisableApi
        }
      />
    </div>
  )
}
